import React from "react";
import Header from "../components/Header";
import Content from "../components/Content";

export default function Page() {
  return (
    <div className="container flex flex-col m-auto w-wCustom bg-background p-customPadding rounded-xl shadow-md">
      <Header />
      <div className="h-px m-5 bg-divider"></div>
      <Content />
    </div>
  );
}
